export interface IPublicTransportConstants {
  singleTicketOneZonePriceInSek: number;
  singleTicketTwoZonesPriceInSek: number;
  singleTicketThreeZonesPriceInSek: number;
  dayTicketOneZonePriceInSek: number;
  dayTicketTwoZonesPriceInSek: number;
  dayTicketThreeZonesPriceInSek: number;
  threeDaysTicketOneZonePriceInSek: number;
  threeDaysTicketTwoZonesPriceInSek: number;
  threeDaysTicketThreeZonesPriceInSek: number;
  periodTicket30DaysOneZonePriceInSek: number;
  periodTicket30DaysTwoZonesPriceInSek: number;
  periodTicket30DaysThreeZonesPriceInSek: number;
  periodTicket90DaysOneZonePriceInSek: number;
  periodTicket90DaysTwoZonesPriceInSek: number;
  periodTicket90DaysThreeZonesPriceInSek: number;
  periodTicket365DaysOneZonePriceInSek: number;
  periodTicket365DaysTwoZonesPriceInSek: number;
  periodTicket365DaysThreeZonesPriceInSek: number;
}

export const PublicTransportConstants: IPublicTransportConstants = {
  singleTicketOneZonePriceInSek: 38,
  singleTicketTwoZonesPriceInSek: 76,
  singleTicketThreeZonesPriceInSek: 114,
  dayTicketOneZonePriceInSek: 125,
  dayTicketTwoZonesPriceInSek: 250,
  dayTicketThreeZonesPriceInSek: 375,
  threeDaysTicketOneZonePriceInSek: 250,
  threeDaysTicketTwoZonesPriceInSek: 500,
  threeDaysTicketThreeZonesPriceInSek: 750,
  periodTicket30DaysOneZonePriceInSek: 445,
  periodTicket30DaysTwoZonesPriceInSek: 667,
  periodTicket30DaysThreeZonesPriceInSek: 1020,
  periodTicket90DaysOneZonePriceInSek: 2405,
  periodTicket90DaysTwoZonesPriceInSek: 3605,
  periodTicket90DaysThreeZonesPriceInSek: 5510,
  periodTicket365DaysOneZonePriceInSek: 8900,
  periodTicket365DaysTwoZonesPriceInSek: 13350,
  periodTicket365DaysThreeZonesPriceInSek: 20400,
};
